import { Link } from 'react-router-dom';
import { Microscope, Mail, MapPin } from 'lucide-react';

const LOGO_URL = `${process.env.PUBLIC_URL}/prasha-logo.jpeg`;

export default function Footer() {
  return (
    <footer className="bg-slate-50 border-t border-slate-100" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="PRASHA CoRe" className="h-8 w-8 rounded-md object-contain" />
              <span className="font-bold text-lg text-[#1a5c5c]" style={{ fontFamily: 'Manrope, sans-serif' }}>PRASHA CoRe</span>
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed">
              Connecting medical ambition with research excellence. Empowering the next generation of medical researchers.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-4 uppercase tracking-wider" style={{ fontFamily: 'Manrope, sans-serif' }}>Platform</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/research', label: 'Research Opportunities' },
                { to: '/courses', label: 'Courses' },
                { to: '/pricing', label: 'Pricing' },
              ].map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-slate-500 hover:text-[#1a5c5c] transition-colors">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-4 uppercase tracking-wider" style={{ fontFamily: 'Manrope, sans-serif' }}>Legal</h4>
            <ul className="space-y-2.5">
              {['Terms & Conditions', 'Privacy Policy', 'Refund Policy'].map((item) => (
                <li key={item}>
                  <span className="text-sm text-slate-500 hover:text-[#1a5c5c] transition-colors cursor-pointer">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-slate-900 mb-4 uppercase tracking-wider" style={{ fontFamily: 'Manrope, sans-serif' }}>Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-sm text-slate-500">
                <Mail className="h-4 w-4 text-[#1a5c5c]" />
                support@prashagroup.com
              </div>
              <div className="flex items-center gap-2 text-sm text-slate-500">
                <MapPin className="h-4 w-4 text-[#1a5c5c]" />
                New Delhi, India
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-200 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">&copy; {new Date().getFullYear()} PRASHA CoRe GROUP. All rights reserved.</p>
          <p className="text-xs text-slate-400">Built with care for the medical research community.</p>
        </div>
      </div>
    </footer>
  );
}
